import Layout from "components/structure/Layout";
import React from "react";
import RuleTable from "../RuleTable";
import { Box, Button } from "@mui/material";
import Delegation from "assets/delegation.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import RuleService from "services/RuleService";
import { useTranslation } from "react-i18next";

const RuleCreation = () => {
  const navigate = useNavigate();
  const {t,i18n} = useTranslation()
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);



  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await RuleService.getRulesList();

      const responseData = response.data.response;
      if (responseData?.length) {
        setData(responseData);
        setLoading(false);
      } else {
        setData([]);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  
  const toggle= async (isActive, data)=> {
    setLoading(true);
    const payload = {
        "conflictId": data.conflictId,
        "ruleName": data.ruleName,
        "functionalityId1": data.functionalityId1,
        "functionalityId2": data.functionalityId2,
        "countryCode": data.countryCode,
        "isDeleted": data.isDeleted,
        "isActive": isActive,
        "createdDateTimeUTC": data.createdDateTimeUTC,
        "createdByUser":data.createdByUser,
  "modifiedDateTimeUTC": data.modifiedDateTimeUTC,
  "modifiedByUser": data.modifiedByUser
    }
    try {
      const response = await RuleService.updateRules(payload);

      const responseData = response.data.response;
      if (response?.data) {
        fetchData()
        //setData(responseData);
        setLoading(false);
      } else {
        //setData([]);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      //setData([]);
    }
    setLoading(false);
  }

  useEffect(() => {
   // setData(sampleData)
    fetchData()
  },[])

  const columns = [
    { label: t("conflicrIndicator.rule"), field: "ruleName", align: "left" },
    { label:  t("conflicrIndicator.functionality1"), field: "functionalityName1", align: "left" },
    { label:  t("conflicrIndicator.functionality2"), field: "functionalityName2", align: "left" },
    { label: t("Action"), field: "action", align: "left" }
  ];



  return (
    <Layout>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box sx={{ display: "hidden" }}></Box>
            <Box>
        
           
              <Button
                // variant="outlined"
                onClick={() => navigate("/createNewRule")}
                sx={{
                  pt: '6px',
                  pr: '15px',  
                  pb: '6px',  
                  pl: '15px', 
                  background:'#ffffff',
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border:'0.739px solid #FFF',
                  color:'#0A3575',
                  fontSize:'20.696px',
                  fontFamily:'Montserrat',
                  textTransform:'capitalize',
                  fontWeight:'500',
                }}
                startIcon={<img src={AddButton} alt="add" />}
              >
                Create New Rule
              </Button>
            </Box>
          </Box>

          <RuleTable columns={columns} rows={data} url={"/editUserCreation"} toggle={toggle}/>
          <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",mt:5,mb:2}}>
          {/* <Button 
          sx={{
            borderRadius: 2,
            background: "#EF7D00",
            color: "#ffffff",
            fontWeight: 600,
            height: 54,
            width: { xs: "100%", md: "156px" },
            "&:hover": {
              backgroundColor: "#EF7D00",
            },
          }}
          onClick={() => navigate("/export")}
          >Export</Button> */}

          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default RuleCreation;
